import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Column from "../Table/ColumnItem";


export const TableRowStyled = styled.div`
  display: flex;
  border-bottom: 1px solid;
  padding: 8px 0;

  font-size: 15px;
  
  width: 95%;
  margin-left: auto;
  margin-right: auto;
  &:hover {
    background-color: inherit;
  }
`;


const TableHeaderTvRange = (props) => {
  const { handleOrderingList, orderingList } = props;

  return (
      <TableRowStyled>
        <Column
            name={"name"}
            text={"Название"}
            orderingList={orderingList}
            handleOrderingList={handleOrderingList}
        />
        <Column
            name={"source_name"}
            text={"Источник"}
            orderingList={orderingList}
            handleOrderingList={handleOrderingList}
        />
        <Column
            name={"created_date"}
            text={"Время создания"}
            orderingList={orderingList}
            handleOrderingList={handleOrderingList}
        />
        <Column
            name={"processed"}
            text={"Обработан"}
            orderingList={orderingList}
            handleOrderingList={handleOrderingList}
        />
        <Column
            name={"prime"}
            text={"Прайм"}
            orderingList={orderingList}
            handleOrderingList={handleOrderingList}
        />
        <Column
            name={"enabled"}
            text={"Активный"}
            orderingList={orderingList}
            handleOrderingList={handleOrderingList}
        />
      </TableRowStyled>
  );
};

export default TableHeaderTvRange;

TableHeaderTvRange.propTypes = {
  handleOrderingList: PropTypes.func,
  orderingList: PropTypes.array
};

TableHeaderTvRange.defaultProps = {
  handleOrderingList: PropTypes.func,
  orderingList: PropTypes.array
};
